import { CenterDialTimeMinMax, EnhancedCenterDialTimeMinMax } from "../../../../Models/CenterDialTime";
import { Error } from "../../../../Utils/Errors";
import { useApi } from "../../../../Utils/useApi";

const useGetDialTimeMinMax = () => {
  const { response, isLoading } = useApi<CenterDialTimeMinMax>({
    url: "Legacy/V0/centers/dialtimeminmax",
    error: Error.GetDialTimeMinMax
  });
  return { response: response && new EnhancedCenterDialTimeMinMax(response), isLoading };
};

export default useGetDialTimeMinMax;
